import { render } from "./empresa-editar.vue?vue&type=template&id=27091641"
import script from "./empresa-editar.vue?vue&type=script&lang=js"
export * from "./empresa-editar.vue?vue&type=script&lang=js"

import "./empresa-editar.vue?vue&type=style&index=0&id=27091641&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__